
const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_h6D0cICMi",
    "aws_user_pools_web_client_id": "26p9p7vci14d99s9i2p33qkdjc",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "peopleCountAPI",
            "endpoint": "https://o75p2oot0d.execute-api.ap-northeast-1.amazonaws.com/prod/",
            "region": "ap-northeast-1"
        },
    ]

};


export default awsmobile;
